/**
 * Style Space v2 (redesign) endpoints — the contract in `docs/backend/STYLE_SPACE_V2_API_GAPS.md`.
 * Every call here sits behind a capability flag (`isStyleSpaceV2ApiEnabled`, BE-170); the UI keeps
 * its client-side fallback while the flag is off.
 */
import { apiClient } from '@/api/api'
import type {
  CreateOutfitResponse,
  SubcategorySearchResponse,
  WardrobeLinkBody,
  WardrobeLinkResponse,
} from './types'

/** §3 */
export const linkWardrobeItem = async (overviewId: number, body: WardrobeLinkBody) =>
  apiClient.post<WardrobeLinkResponse>(`/playground/user-wardrobe/${overviewId}/link`, {
    product_id: body.productId,
    ...(body.variantId != null ? { variant_id: body.variantId } : {}),
  })

/** §6 */
export const duplicateOutfit = async (outfitId: number) =>
  apiClient.post<CreateOutfitResponse>(`/playground/outfits/${outfitId}/duplicate`)

/** §8 */
export const searchSubcategories = async (query: string, mainCategoryId: number | null) =>
  apiClient.get<SubcategorySearchResponse>('/ml-classification/subcategories/search', {
    params: {
      q: query,
      ...(mainCategoryId != null ? { main_category_id: mainCategoryId } : {}),
    },
  })
